define([
	"csi/access/crews",
    "csi/api",
    "csi/xml",
], function(crews,api,xml) {
	
	api.setRelationshipAccess("SRLineItem","SRLineItemPackage",true);
	
	return {
		onAccessActionSupplierRequestDPTemplate: function(/*Context*/ctx, /*Action*/action) {
			return crews.isInRoles(["Supplier Request Administrator"], ctx.getNode());
		},
		onAccessActionEditDataPackage: function(/*Context*/ctx, /*Action*/action) {
			return !xml.isEmptyURL(ctx.getNode().SRLineItemPackage);
		}
	};
});